/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { FeedbackForm } from '../../components/FeedbackForm/FeedbackForm';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';

import messages from './messages';

const styles = cssMap({
	container: {
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
	},
});

interface AcceptRejectProps {
	onAccept: () => void;
	onBadResponseButtonClick: () => void;
	onGoodResponseButtonClick: () => void;
	onReject: () => void;
}

export const AcceptRejectScreen = ({
	onAccept,
	onReject,
	onBadResponseButtonClick,
	onGoodResponseButtonClick,
}: AcceptRejectProps) => {
	const { formatMessage } = useIntl();

	return (
		<FloatingContainer
			data-testid="accept-reject-screen"
			rainbowBorderAnimation={false}
			rainbowBorder={false}
			disablePadding
			enableMaxWidth
		>
			<Flex justifyContent="space-between" alignItems="center" xcss={styles.container}>
				<Flex gap="space.050">
					<FeedbackForm
						onBadResponseButtonClick={onBadResponseButtonClick}
						onGoodResponseButtonClick={onGoodResponseButtonClick}
					/>
				</Flex>
				<Flex gap="space.100">
					<Button appearance="subtle" onClick={onReject}>
						{formatMessage(messages.rejectLabel)}
					</Button>
					<Button appearance="primary" onClick={onAccept} autoFocus>
						{formatMessage(messages.acceptLabel)}
					</Button>
				</Flex>
			</Flex>
		</FloatingContainer>
	);
};
